import { gql } from 'graphql-request';
import { request } from '../graphql';

export const GET_EMBED_TOKEN = gql`
  query luzmoEmbedToken($input: LuzmoSsoInput!) {
    luzmoEmbedToken(input: $input) {
      id
      token
    }
  }
`;

export interface GetLuzmoEmbedToken {
  luzmoEmbedToken: {
    id: string;
    token: string;
  };
}

interface GetLuzmoEmbedTokenArgs {
  realTime: boolean;
  accessOfDashboard?: string;
}

export const getLuzmoEmbedToken = (args: GetLuzmoEmbedTokenArgs) =>
  request<GetLuzmoEmbedToken>(GET_EMBED_TOKEN, { input: { ...args }} );
